<template>
  <div>
    <v-app-bar app flat class="blue-grey lighten-5">
      <img :src="vstlogo" height="50" />
      
      <slot name="Title" />
      
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <slot name="Main" class="transparent"></slot>
      </v-container>
      <div height="150" /> 
    </v-main> 
    <v-footer app color="blue-grey darken-1" class="white--text">
      <span>VST ECS (Thailand) Co.,Ltd.</span> <v-spacer />
      <v-spacer />
      <span>&copy; 2022 </span>
    </v-footer> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0,
      },
      vstlogo: require("@/assets/logo.png"),
    };
  },
  created() {
    this.onResize();
    window.addEventListener("resize", () => this.onResize());
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    logout() {
      localStorage.removeItem("vhrtoken");
      location.reload();
    },
  },
  watch: {
    drawerRight() {
      this.$vuetify.goTo(0, { duration: 0, offset: 0 });
      if (!this.drawerRight) {
        this.stry = ``;
        this.showmenu = true;
      } else {
        this.stry = `margin-left: 60px`;
        this.showmenu = false;
      }
    },
  },

  computed: {},
};
</script>
 
<style>

 .grecaptcha-badge {
  width: 0px !important;
  overflow: hidden !important;
  transition: all 0.3s ease !important;
  left: 4px !important;
  bottom: 40px !important;
}
.grecaptcha-badge:hover {
  width: 256px !important;
}
</style>